/** Espace entre deux onglets (`gap-x-5`), en pixels : il compte dans la place qu'ils prennent. */
export const tabGap = 20

/**
 * Les onglets qui tiennent sur une ligne de `available` pixels, dans l'ordre :
 * tous s'ils tiennent, sinon les premiers et le bouton « autres rubriques ».
 * L'onglet ouvert reste toujours visible : il prend la derniere place s'il
 * n'etait pas parmi les premiers.
 */
export function visibleTabs(widths: number[], current: number, available: number, moreWidth: number): number[] {
  const all = widths.map((_width, index) => index)
  const width = (indexes: number[]) =>
    indexes.reduce((sum, index) => sum + widths[index]!, 0) + tabGap * Math.max(indexes.length - 1, 0)

  if (width(all) <= available) {
    return all
  }

  for (let count = widths.length - 1; count >= 1; count--) {
    const first = all.slice(0, count)
    const shown = first.includes(current) ? first : [...first.slice(0, count - 1), current]
    if (width(shown) + tabGap + moreWidth <= available) {
      return shown
    }
  }

  return [current]
}
